import { render, staticRenderFns } from "./BalanceHistoryTable.vue?vue&type=template&id=24f91c3c"
import script from "./BalanceHistoryTable.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports